import React from "react";
const CardLoader = () => {

  return (
    <div className="card-loader card-loader--tabs"></div>
  );
};

export default CardLoader;
